<template>
  <div class="md-layout">
    <md-card class="m-0">
      <md-card-header>
        Industry Market Insights <span class="info">{{ period }}</span>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <!--<div class="md-layout-item p-0">
            <div class="tbldata_info">Total Industry Sales ({{ area }})</div>
          </div>-->
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0" v-if="main">
            <md-table
              v-model="main"
              table-header-color="blue"
              class="profit-and-loss-table"
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
              >
                <md-table-cell md-label="Main">
                    {{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Value">
                  {{ item.value }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0" v-if="penetration">
            <md-table
              v-model="penetration"
              table-header-color="blue"
              class="profit-and-loss-table"
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
              >
                <md-table-cell md-label="Penetration">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Value">
                  {{ item.value }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <div class="md-layout-item md-medium-size-100 md-size-100 p-0" v-if="income">
            <md-table
              v-model="income"
              table-header-color="blue"
              class="profit-and-loss-table"
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
              >
                <md-table-cell md-label="Demographics">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Value">
                  {{ item.value }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
  <!-- <div class="content if-profile">
    <div class="md-layout finanical-insights-body">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
      >
        <CRHeader />
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <div class="md-toolbar-row p-0">
            <nav-tabs-card>
              <template slot="content">
                <div class="md-layout">
                  <md-card class="if_card">
                    <md-card-header>
                      Industry Market Insights <span class="info">{{ period }}</span>
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  Total Industry Sales ({{ area }})
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  v-if="main"
                                >
                                  <md-table
                                    v-model="main"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Main">
                                        <div class="md-table-side-label">
                                          {{ item.name }}
                                        </div>
                                      </md-table-cell>
                                      <md-table-cell md-label="">
                                        {{ item.value }}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  v-if="penetration"
                                >
                                  <md-table
                                    v-model="penetration"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Penetration">
                                        <div class="md-table-side-label">
                                          {{ item.name }}
                                        </div>
                                      </md-table-cell>
                                      <md-table-cell md-label="">
                                        {{ item.value }}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  v-if="income"
                                >
                                  <md-table
                                    v-model="income"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Income">
                                        <div class="md-table-side-label">
                                          {{ item.name }}
                                        </div>
                                      </md-table-cell>
                                      <md-table-cell md-label="">
                                        {{ item.value }}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { NavTabsCard } from '@/components';
import { mapActions, mapState } from 'vuex';
import CRHeader from './CRHeader.vue';

export default {
  components: {
    // NavTabsCard,
    // CRHeader,
  },
  props:['headerData'],
  data() {
    return {};
  },
   computed: {
    user(){
      return this.$store.state.user.user;
    },
    companyReport() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    period() {
      return this.companyReport ? this.companyReport['MR']['period'] : '';
    },
    area() {
      return this.companyReport ? this.companyReport['MR']['area'] : '';
    },
    main() {
      return this.companyReport
        ? Object.keys(this.companyReport['MR']['main']).map((key) => {
            return {
              name: key,
              value: this.companyReport['MR']['main'][key],
            };
          })
        : null;
    },
    penetration() {
      return this.companyReport
        ? Object.keys(this.companyReport['MR']['penetration']).map((key) => {
            return {
              name: key,
              value: this.companyReport['MR']['penetration'][key],
            };
          })
        : null;
    },
    income() {
      return this.companyReport
        ? Object.keys(this.companyReport['MR']['income']).map((key) => {
            return {
              name: key,
              value: this.companyReport['MR']['income'][key],
            };
          })
        : null;
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.industry-insights-table {
  display: flex;
  align-items: flex-start;
}
</style>
